function initReviewsModal() {
    const modal = document.getElementById('reviewsModal');
    const btn = document.getElementById('showReviewsBtn');
    const span = document.getElementById('closeReviewsModal');

    // Open modal
    if (btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (modal) {
                // Ensure modal is visible before adding show class
                modal.style.display = 'block';
                // Small delay to ensure display change is applied
                setTimeout(() => {
                    modal.classList.add('show');
                }, 10);
                // Prevent body scrolling
                document.body.style.overflow = 'hidden';
                // Disable header interactions
                const header = document.querySelector('header');
                if (header) {
                    header.style.pointerEvents = 'none';
                    header.style.userSelect = 'none';
                }
            }
        });
    }

    // Close modal
    if (span) {
        span.addEventListener('click', function(e) {
            e.preventDefault();
            closeModal();
        });
    }

    // Close modal when clicking outside of it
    window.addEventListener('click', function(event) {
        if (event.target == modal) {
            closeModal();
        }
    });

    // Function to close modal with smooth transition
    function closeModal() {
        modal.classList.remove('show');
        // Restore body scrolling
        document.body.style.overflow = '';
        // Re-enable header interactions
        const header = document.querySelector('header');
        if (header) {
            header.style.pointerEvents = '';
            header.style.userSelect = '';
        }
        
        // Wait for transition to complete before hiding modal
        setTimeout(() => {
            if (!modal.classList.contains('show')) {
                modal.style.display = 'none';
            }
        }, 300); // Match the CSS transition duration
    }

    // Tooltip functionality
    const grsTooltip = document.getElementById('grsTooltip');
    
    if (grsTooltip) {
        grsTooltip.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            this.classList.toggle('active');
        });
        
        // Close tooltip when clicking outside
        document.addEventListener('click', function(e) {
            if (!grsTooltip.contains(e.target)) {
                grsTooltip.classList.remove('active');
            }
        });
    }

    // Sort reviews functionality
    const sortButton = document.getElementById('sortButton');
    const sortDropdown = document.getElementById('sortDropdown');
    const sortOptions = document.querySelectorAll('.sort-option');
    
    if (sortButton && sortDropdown) {
        // Toggle dropdown
        sortButton.addEventListener('click', function(e) {
            e.stopPropagation();
            sortDropdown.classList.toggle('show');
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!sortButton.contains(e.target) && !sortDropdown.contains(e.target)) {
                sortDropdown.classList.remove('show');
            }
        });
        
        // Handle sort option selection
        sortOptions.forEach(option => {
            option.addEventListener('click', function() {
                const selectedValue = this.dataset.value;
                
                // Update checkmarks
                sortOptions.forEach(opt => opt.querySelector('.checkmark')?.remove());
                this.innerHTML += '<div class="checkmark">✓</div>';
                
                // Close dropdown
                sortDropdown.classList.remove('show');
                
                // Sort reviews
                const reviewList = document.querySelector('.review-list');
                const reviews = Array.from(reviewList.querySelectorAll('.review'));
                
                reviews.sort(function(a, b) {
                    switch(selectedValue) {
                        case 'newest':
                            return new Date(b.dataset.date) - new Date(a.dataset.date);
                        case 'oldest':
                            return new Date(a.dataset.date) - new Date(b.dataset.date);
                        case 'highest':
                            return parseFloat(b.dataset.rating) - parseFloat(a.dataset.rating);
                        case 'lowest':
                            return parseFloat(a.dataset.rating) - parseFloat(b.dataset.rating);
                        default:
                            return 0;
                    }
                });
                
                // Clear the review list and append sorted reviews
                reviewList.innerHTML = '';
                reviews.forEach(review => reviewList.appendChild(review));
            });
        });
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsModal);
} else {
    initReviewsModal();
} 